/* eslint-disable react/jsx-props-no-spreading */
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  LinearProgress,
  makeStyles,
  Slide,
  Toolbar,
  useMediaQuery,
  useTheme
} from "@material-ui/core";
import { NavigateBefore, NavigateNext } from "@material-ui/icons";
import React, { useState, forwardRef } from "react";
import { Document, Page } from "react-pdf";

const useStyles = makeStyles({
  dialogPaper: {
    maxHeight: "80vh"
  },
  documentContainer: {
    display: "flex",
    justifyContent: "flex-end",
    flexDirection: "column",
    margin: "0 auto",
    "& .react-pdf__Page__canvas": {
      margin: "0 auto",
      width: "auto !important",
      height: "100% !important"
    }
  }
});

const Transition = forwardRef((props, ref) => {
  return <Slide direction="up" ref={ref} {...props} />;
});

const PdfViewerModal = ({ documentUrl, isOpen, handleClose }) => {
  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const onLoadSuccess = ({ numPages }) => {
    setTotalPages(numPages);
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      fullWidth
      maxWidth="lg"
      classes={{ paper: classes.dialogPaper }}
      open={isOpen}
      TransitionComponent={Transition}
      onClose={handleClose}
    >
      <DialogTitle>Visualizzazione Certificato</DialogTitle>
      <DialogContent>
        <div id="pdfDiv" className={classes.documentContainer}>
          <Document file={documentUrl} onLoadSuccess={onLoadSuccess}>
            <Page pageNumber={page} />
          </Document>
          <Toolbar>
            <IconButton disabled={page <= 1} onClick={() => setPage(page - 1)}>
              <NavigateBefore />
            </IconButton>
            <IconButton disabled={page >= totalPages} onClick={() => setPage(page + 1)}>
              <NavigateNext />
            </IconButton>
            <LinearProgress
              style={{ width: "100%" }}
              variant="determinate"
              value={((page - 1) / (totalPages - 1)) * 100}
            />
          </Toolbar>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Chiudi
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PdfViewerModal;
